import { useTranslation } from "react-i18next";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const ShipmentChart = () => {
  const { t } = useTranslation();

  const data = [
    { day: t("sa"), value: 7 },
    { day: t("su"), value: 6 },
    { day: t("mo"), value: 8 },
    { day: t("tu"), value: 7.5 },
    { day: t("we"), value: 5 },
    { day: t("th"), value: 3.5 },
    { day: t("fr"), value: 4.5 },
  ];
  return (
    <div className="p-5 bg-white rounded-2xl">
      <div className="flex flex-wrap items-center justify-between gap-4 my-4 capitalize md:flex-nowrap">
        <h2 className="font-medium">{t("shipmentsStatsLast7Days")}</h2>
        <div className="flex items-center gap-2 text-xs text-right text-mainGray">
          <p>
            <span>{t("totalShipments-")}</span> 45
          </p>
          <p>
            <span>{t("dailyAvg-")}</span>6
          </p>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data} margin={{ top: 10, right: 50, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorLine" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3B82F6" stopOpacity={0.4} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis
            axisLine={false}
            tickLine={false}
            dataKey="day"
            textAnchor="middle"
            padding={{ left: 30, right: 30 }}
          />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#3B82F6"
            strokeWidth={2}
            dot={false}
            fill="url(#colorLine)"
            isAnimationActive={true}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
export default ShipmentChart;
